import React from 'react';
import { Spinner } from '../../../../flayr-components';

interface ICalculatingStepProps {}

const CalculatingStep: React.FC<React.PropsWithChildren<React.PropsWithChildren<ICalculatingStepProps>>> = ({}) => {
  return (
    <div>
      <Spinner showing />
      <div className="mt-8 text-2xl font-medium text-center">
        Calculating pricing
      </div>
    </div>
  );
};
export default CalculatingStep;
